// import { USER_ACTIVITY_COLOR_PALETTE, USER_COLOR_PALETTE } from '../../constants'

export function getActivityColor(userColor: string = '#2F4870') {
  return userColor
  // const normalizedUserColor = userColor.toUpperCase()
  // const userColorIndex = USER_COLOR_PALETTE.indexOf(normalizedUserColor)
  // if (userColorIndex === -1) {
  //   return USER_ACTIVITY_COLOR_PALETTE[0]
  // }
  // const activityColorIndex = userColorIndex % USER_ACTIVITY_COLOR_PALETTE.length
  // return USER_ACTIVITY_COLOR_PALETTE[activityColorIndex]
}
